import React from 'react'
import { PlainField } from './PlainField'

const TextField = ({ ...props }) => {
	return (<PlainField {...props} />)
}

export default TextField